module.exports = __webpack_public_path__ + "img/4.fb78b0f3.jpg";